<div class="row">
  <div class="col-md-12 col-sm-12">
    <div class="header">
      <div class="d-flex flex-row align-items-center">
        <span>{{'measure.roi' | translate}}</span>
        <achoo-icon-tooltip [tooltipMsg]="'info_box.measure.roi_title' | translate"></achoo-icon-tooltip>
      </div>
      <div class="report-content-setting" *ngIf="!isExportingPdfReport">
        <a (click)="openSetting()">
          <img src="assets/images/Light_Edit_Icon.svg" class="roi-setting-icon">
        </a>
      </div>
    </div>
    <div class="d-flex flex-row flex-auto kpi-container" *ngIf="!haveNoData">
      <div class="influencers-kpi-block" *ngIf="influencersKpi">
        <div class="d-flex flex-row flex-auto">
          <div class="d-flex flex-column flex-auto kpi-content">
            <div class="kpi-header">{{'measure.influencer_col_name' | translate}}</div>
            <div class="kpi-value">
              <span placement="bottom"
                    ngbTooltip="{{'info_box.measure.roi_influencers' | translate}}">
                {{influencersKpi.value | thousandNumberSuffix}}
              </span>
            </div>
          </div>
          <div class="roi-border-left-line"></div>
        </div>
      </div>
      <div class="posts-kpi-block" *ngIf="postKpi">
        <div class="d-flex flex-row flex-auto">
          <div class="d-flex flex-column flex-auto kpi-content">
            <div class="kpi-header">{{'measure.posts_col_name' | translate}}</div>
            <div class="kpi-value">
              <span placement="bottom"
                    ngbTooltip="{{'info_box.measure.roi_post' | translate}}">
                {{postKpi.value | thousandNumberSuffix}}
              </span>
            </div>
          </div>
          <div class="roi-border-left-line"></div>
        </div>
      </div>
      <div class="impressions-kpi-block" *ngIf="impressionKpi">
        <div class="d-flex flex-row flex-auto">
          <div class="d-flex flex-column flex-auto kpi-content">
            <div class="kpi-header">{{'measure.impression_col_name' | translate}}</div>
            <div class="kpi-value">
              <span placement="bottom"
                    ngbTooltip="{{'info_box.measure.roi_impression' | translate}}">
                {{impressionKpi.value | thousandNumberSuffix}}
              </span>
            </div>
          </div>
          <div class="roi-border-left-line"></div>
        </div>
      </div>
      <div class="reach-kpi-block" *ngIf="reachKpi">
        <div class="d-flex flex-row flex-auto">
          <div class="d-flex flex-column flex-auto kpi-content">
            <div class="kpi-header">{{'measure.reach_col_name' | translate}}</div>
            <div class="kpi-value">
              <span placement="bottom"
                    ngbTooltip="{{'info_box.measure.roi_reach' | translate}}">
                {{reachKpi.value | thousandNumberSuffix}}
              </span>
            </div>
          </div>
          <div class="roi-border-left-line"></div>
        </div>
      </div>
      <div class="roi-value-block" *ngIf="roiValue">
        <div class="d-flex flex-row flex-auto">
          <div class="d-flex flex-column flex-auto kpi-content">
            <div class="kpi-header">{{'measure.roi_col_name' | translate}}</div>
            <div class="kpi-value">
              <span placement="bottom"
                    ngbTooltip="{{'info_box.measure.roi_total' | translate}}">
                {{roiValue.value | currencyFormatting:currency }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-12" *ngIf="!haveNoData">
    <div class="seperation-line-roi-report"></div>
  </div>
  <div class="col-md-12 col-sm-12 roi-report-table" *ngIf="!haveNoData">
    <div class="d-flex flex-column flex-auto">
      <div class="d-flex flex-row flex-auto roi-header-line" *ngIf="shouldShowHeader">
        <div class="influencer-info-col">
          <div class="d-flex flex-row flex-auto">
            <div class="roi-table-header index-col-header">#</div>
            <div class="roi-table-header influencer-details-col flex-auto">{{'measure.roi_table.header.influencer' | translate}}</div>
            <div class="roi-table-header platform-icon-col"></div>
          </div>
        </div>
        <div class="posts-col"><div class="roi-table-header">{{'measure.roi_table.header.posts' | translate}}</div></div>
        <div class="impression-col"><div class="roi-table-header">{{'measure.roi_table.header.impression' | translate}}</div></div>
        <div class="reach-col"><div class="roi-table-header reach-header">{{'measure.roi_table.header.reach' | translate}}</div></div>
        <div class="roi-value-col"><div class="roi-table-header roi-header">{{roiValueColHeader}}</div></div>
      </div>

      <div class="d-flex flex-column flex-auto roi-body-section">
        <div class="d-flex flex-row flex-auto roi-row" *ngFor="let data of listInfluencer; let i = index"
             [ngClass]="{'odd': i % 2 !== 0, 'even': i % 2 === 0, 'break-line': i % 13 === 0}">
          <a class="d-flex flex-row influencer-info-col"
             [routerLink]="['/influencer/' + data.influencerId +'/overview']"
             [queryParams]="{activeAccount: activeAccount}">
            <div class="d-flex index-col">{{calculateIndex(i)}}</div>
            <div class="d-flex flex-auto roi-col-influencer-name">
              <div>
                <achoo-user-avatar [showCountryFlagIcon]="findCountryCode(data) !== null"
                                   [userCountryCode]="findCountryCode(data)"
                                   [userAvatarPicture]="data.influencerImage"
                                   [avatarWidth]="3.5"
                                   [avatarHeight]="3.5"
                                   [countryWidth]="1.15"
                                   [countryHeight]="1.15"
                                   (afterImageLoaded)="onLoadedAvatarImage()">
                </achoo-user-avatar>
              </div>
              <div class="influencer-name-wrapper">{{data.influencerName}}</div>
            </div>
            <div class="d-flex justify-content-end platform-icon-col">
              <div class="d-flex flex-row">
                <img *ngIf="data.platformBlogs" src="assets/images/platform/Blogger.svg" width="20" height="20">
                <img *ngIf="data.platformFacebook" src="assets/images/platform/Facebook.svg" width="20" height="20">
                <img *ngIf="data.platformInstagram" src="assets/images/platform/Instagram.svg" width="20" height="20">
                <img *ngIf="data.platformYoutube" src="assets/images/platform/Youtube.svg" width="20" height="20">
                <img *ngIf="data.platformTiktok" src="assets/images/platform/TikTok.svg" width="20" height="20">
              </div>
            </div>
          </a>
          <div class="d-flex posts-col">
            <div class="roi-col-number">
              {{data.post_num | thousandNumberSuffix}}
            </div>
          </div>
          <div class="d-flex impression-col">
            <div class="roi-col-number"
                 placement="bottom"
                 ngbTooltip="{{'info_box.measure.roi_impression_col' | translate}}">
              {{data.impression | thousandNumberSuffix}}
            </div>
          </div>
          <div class="d-flex reach-col">
            <div class="roi-col-number"
                 placement="bottom"
                 ngbTooltip="{{'info_box.measure.roi_reach_col' | translate}}">
              {{data.reach | thousandNumberSuffix}}
            </div>
          </div>
          <div class="d-flex roi-value-col">
            <div class="roi-col-number"
                 placement="bottom"
                 ngbTooltip="{{'info_box.measure.roi_col' | translate}}">
              {{data.ROI_value | thousandNumberSuffix}}
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end roi-pagination-container" *ngIf="!isExportingPdfReport">
        <achoo-pagination [minPage]="1" [maxPage]="maxPage" (pageChange)="onChangePage($event)" ></achoo-pagination>
      </div>
    </div>
  </div>
  <div *ngIf="haveNoData" class="col-md-12 col-sm-12">
    <div class="message">
      <span>{{'measure.noData' | translate}}</span>
    </div>
  </div>
</div>
<achoo-popup #roiSettingPopup
             [modelTitle]="'measure.roi_setting.title_popup' | translate"
             [acceptBtnLabel]="'common.btn.save' | translate"
             (acceptCallback)="onSaveRoiSetting()"
             [cancelBtnLabel]="'common.btn.cancel' | translate"
             [isRoiSettingPopup]="true"
             (cancelCallback)="closeSetting()">
  <roi-setting [roiSetting]="roiSetting">
  </roi-setting>
</achoo-popup>
<achoo-popup #roiErrorNotification
             [isNotification]="true"
             modelTitle="{{'notification.error' | translate}}">
  <span>{{'measure.roi_setting.api_failed' | translate}}</span>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/measure/content/roi-report/roi-report.component.html